import { render, staticRenderFns } from "./inventoryQueryList.vue?vue&type=template&id=8e15103a&scoped=true"
import script from "./inventoryQueryList.vue?vue&type=script&lang=js"
export * from "./inventoryQueryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryQueryList.vue?vue&type=style&index=0&id=8e15103a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e15103a",
  null
  
)

export default component.exports